import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import LoanStore from '@/loan/store';
import { Route } from 'vue-router';

const loanStore = getModule(LoanStore, store);

export const loanResolver = async (to: Route): Promise<void> => {
	const { loanId } = to.params;
	await loanStore.getAndSetLoan(loanId);
};
